import type { ToolCall } from 'services/types/analysis';

import baseWorkloadApi from './baseWorkloadApi';

export type DbOutput = Record<string, string | number | object>;
export type DbResponse = { results: DbOutput[]; time: number };
const dbRequestsApi = baseWorkloadApi.injectEndpoints({
  endpoints: (build) => ({
    adminGenerateAIQuery: build.mutation({
      query: (body: { userQuery: string }) => ({
        url: '/admin/db/ai_generate_query',
        method: 'POST',
        body,
      }),
      transformResponse: (response: { description: string; sqlQuery: string }) => response,
    }),
    adminExecuteQuery: build.mutation({
      query: (body: { userQuery: string }) => ({
        url: '/admin/db/execute',
        method: 'POST',
        body,
      }),
      transformResponse: (queryResponse: DbResponse): DbResponse => queryResponse,
    }),
    adminGenerateResultsAnalysis: build.mutation({
      query: (body: { userQuery: string; sql: string; results: DbOutput[] }) => ({
        url: '/admin/db/ai_generate_results_analysis',
        method: 'POST',
        body,
      }),
      transformResponse: (response: ToolCall[]): ToolCall[] => response,
    }),
  }),
  overrideExisting: false,
});

export const {
  useAdminGenerateAIQueryMutation,
  useAdminExecuteQueryMutation,
  useAdminGenerateResultsAnalysisMutation,
} = dbRequestsApi;
